var map = {
	"./de/dummies.json": 2119,
	"./en/dummies.json": 2120,
	"./es/dummies.json": 2121,
	"./fr/dummies.json": 2122,
	"./it/dummies.json": 2123,
	"./ja/dummies.json": 2124,
	"./nl/dummies.json": 2125,
	"./sv/dummies.json": 2126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2118;